import  { useRef, useEffect, useState } from 'react';


const Captcha = ({ onValidate, submitAttempted }) => {
    const canvasRef = useRef(null)
    const [code, setCode] = useState('')
    const [inputValue, setInputValue] = useState('')
    const [isValid, setIsValid] = useState(false)
    const [isSubmitted, setIsSubmitted] = useState(false)
    useEffect(() => {
        if (submitAttempted) {
          setIsSubmitted(true)
          const valid = inputValue === code
          setIsValid(valid)
          onValidate(valid)
        }
      }, [submitAttempted, inputValue, code, onValidate])
  // Generate random number for CAPTCHA
  const generateCode = () => {
    const newCode = Math.floor(100000 + Math.random() * 900000).toString();
    setCode(newCode);
    return newCode;
  };

  // Draw CAPTCHA code on canvas
  const drawCode = (codeStr) => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    
    // Set canvas dimensions
    canvas.width = 200;
    canvas.height = 80;

    // Draw each character with transformations
    codeStr.split('').forEach((char, i) => {
      ctx.save();
      // Random rotation between -15 and 15 degrees
      ctx.rotate((Math.random() * 30 - 15) * Math.PI / 180);
      ctx.font = '40px Arial';
      ctx.fillStyle = `rgb(${Math.random() * 255},${Math.random() * 255},${Math.random() * 255})`;
      ctx.fillText(char, 20 + i * 30, 50);
      ctx.restore();
    });
  };

  // Handle CAPTCHA refresh
  const handleRefresh = () => {
    const newCode = generateCode();
    drawCode(newCode);
    setInputValue('');
    setIsValid(false);
  };

  // Handle form submission
  const handleInputChange = (e) => {
    const value = e.target.value
    setInputValue(value)
    const valid = value === code
    console.log(value, valid)
    setIsValid(valid)
    onValidate(valid)
  }

  // Initial setup
  useEffect(() => {
    const initialCode = generateCode();
    drawCode(initialCode);
  }, []);

  return (
    <div className="captcha-container">
      <div className="captcha-base">
        <canvas ref={canvasRef} />
        
      </div>
      
      <div className='flex items-center'>
          <input
            type="text"
            value={inputValue}
            onChange={handleInputChange}
            placeholder="Enter CAPTCHA code"
            className={`captcha-input ${isSubmitted ? (isValid ? 'valid' : 'invalid') : ''}`}
          />
          <button
              type="button"
              className="flex items-center justify-center py-2 px-3 bg-[#4c45e4] text-white"
              onClick={handleRefresh}
            >
              ↻
            </button>
      </div>

      {isSubmitted && (
        <div className={`validation-message ${isValid ? 'valid' : 'invalid'}`}>
          {isValid ? '✓ CAPTCHA verified' : '✗ CAPTCHA verification failed'}
        </div>
      )}
    </div>
  );
};

export default Captcha;